import { CircularProgress } from '@mui/material';
import UpdateTeacherForm from './update-teacher/UpdateTeacherForm';
import StudentTableSelector from './update-teacher/StudentTableSelector';
import { useAdmin } from '../../../../context/AdminContextProvider';
import { getDataFromIncluded } from '../../../../hooks/AdminUtilityHooks';
import { unique } from '../../../../../../utils/ArrayUtils';
import './UpdateTeacherPanel.scss';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  loading: false,
  onTeacherFormDataChange: () => null,
  teacherDataObject: {
    data: {
      relationships: {
        students: [],
      },
    },
  },
  teacherFormData: {},
  teacherSelectedStudentIds: [],
  onStudentSelect: () => null,
};
const UpdateTeacherPanel = (p) => {
  const {
    loading,
    teacherFormData,
    teacherDataObject,
    teacherSelectedStudentIds,
    onTeacherFormDataChange,
    onStudentSelect,
  } = { ...defaultProps, ...filterUndefined(p) };

  const { adminDomain } = useAdmin();
  const { usersAndLicensesData } = adminDomain.domainData;

  const studentListFromTeacherData = getDataFromIncluded(
    usersAndLicensesData
    && usersAndLicensesData.data
    && usersAndLicensesData.data.relationships
      ? usersAndLicensesData.data.relationships.students.data : [],
    usersAndLicensesData.included || [],
  );
  const studentListFromTeacherDataObject = getDataFromIncluded(
    teacherDataObject && teacherDataObject.data.relationships
      ? teacherDataObject.data.relationships.students.data
      : [], teacherDataObject.included || [],
  );

  const teacherStudentSelectorTableData = [
    ...studentListFromTeacherData,
    ...studentListFromTeacherDataObject,
  ].map((st) => ({
    id: st.id,
    username: st.attributes.userName,
    firstName: st.attributes.firstName,
    lastName: st.attributes.lastName,
    isActive: st.attributes.isActive,
  }));

  return (
    <div className='update-admin-teacher-panel'>
      {
        loading ? (
          <div className='loading-teacher-data'>
            <CircularProgress className='loading-icon' />
            Loading
          </div>
        ) : (
          <>
            <UpdateTeacherForm
              teacherFormData={teacherFormData}
              onDataChange={onTeacherFormDataChange}
            />
            <StudentTableSelector
              selectedStudentIds={teacherSelectedStudentIds}
              teacherStudentSelectorTableData={unique(teacherStudentSelectorTableData, 'id')}
              onDataChange={onStudentSelect}
            />
          </>
        )
      }
    </div>
  );
};

export default UpdateTeacherPanel;
